import React, { useEffect } from "react";
import { useAppDispatch } from "./useAppDispatch";
import { useAppSelector } from "./useAppSelector";
import { setTheme } from "features/slices/themeSlice";
import { useAccount } from "./useAccount";
import { generateThemeColor } from "utils/appUtils";

const useInitTenantSetting = () => {
  const { tenantThemeColor } = useAppSelector((state) => state.tenant);
  const { account } = useAccount();
  const customTheme = generateThemeColor(tenantThemeColor);
  const dispatch = useAppDispatch();

  useEffect(() => {
    async function initTenantStore() {
      if (!account) return;
      dispatch(setTheme(customTheme));
    }

    initTenantStore();
  }, [account]);

  return null;
};

export default useInitTenantSetting;
